import type { WorkoutSessionItem } from '../../types';
import { Button } from '../ui/Button';

interface CommentComposerProps {
  commentText: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  items?: WorkoutSessionItem[];
  targetItemId?: string;
  onChangeTarget?: (id?: string) => void;
  allowClearTarget?: boolean;
}

export function CommentComposer({
  commentText,
  onChange,
  onSubmit,
  items,
  targetItemId,
  onChangeTarget,
  allowClearTarget = true,
}: CommentComposerProps) {
  return (
    <div className="space-y-2">
      {items && onChangeTarget && (
        <div className="flex items-center gap-2">
          <select
            className="form-field flex-1"
            value={targetItemId || ''}
            onChange={(e) => onChangeTarget(e.target.value || undefined)}
          >
            <option value="">Session-level comment</option>
            {items.map((item) => (
              <option key={item.id} value={item.id}>
                {item.exerciseName}
              </option>
            ))}
          </select>
          {allowClearTarget && targetItemId && (
            <Button
              onClick={() => onChangeTarget(undefined)}
              variant="ghost"
              size="sm"
            >
              Clear
            </Button>
          )}
        </div>
      )}
      <textarea
        className="form-textarea max-w-none"
        placeholder="Add a comment"
        value={commentText}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button onClick={onSubmit} className="w-full">
        Post comment
      </Button>
    </div>
  );
}
